import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IKpiConf, defaultValue } from 'app/shared/model/kpi-conf.model';

const initialState: EntityState<IKpiConf> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/kpi-confs';

// Actions

export const getEntitiesByPreset = createAsyncThunk(
  'kpiConf/fetch_entity_list_by_preset',
  async (params: { presetId?: number | null; companyId?: number | null }) => {
    const { presetId, companyId } = params;
    const presetParam = presetId !== undefined && presetId !== null ? presetId : 'null';

    let requestUrl = `${apiUrl}/preset/${presetParam}`;

    if (companyId !== null && companyId !== undefined) {
      requestUrl += `?companyId=${companyId}`;
    }

    return axios.get<IKpiConf[]>(requestUrl);
  }
);

// slice

export const KpiConfSlice = createEntitySlice({
  name: 'kpiConf',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEntitiesByPreset), (state, action) => {
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
        };
      })
      .addMatcher(isPending(getEntitiesByPreset), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      });
  },
});

export const { reset } = KpiConfSlice.actions;

// Reducer
export default KpiConfSlice.reducer;
